module.exports = __webpack_public_path__ + "static/img/logo.aa35a28a.png";